import React from 'react';
import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';
import StatusBadge from '../../../v2/MUI_custom_component/Badge/StatusBadge';
import { CustomButton } from '../../../v2/MUI_custom_component';
import { useNavigate } from 'react-router-dom';
import { toCapitalized } from '../../../v2/Utils/Capitalize';

const DispatchStatusSection = ({ title = "Dispatch Status", showViewAll = true, dpList = [] }) => {
    const navigate = useNavigate();

    const handleViewAll = () => {
        navigate('/dispatch-status-list');
    };

    const handleViewDetails = (dpId) => {
        navigate(`/dispatch-plan-detail/${dpId}`);
    };

    const getStatusColor = (status) => {
        const statusColorMap = {
            'pending': '#FF9800',
            'approved': '#4CAF50',
            'partially_delivered': '#2196F3',
            'delivered': '#4CAF50',
            'cancelled': '#F44336'
        };
        return statusColorMap[status] || '#757575';
    };

    const getStatusLabel = (status) => {
        const statusLabels = {
            pending: 'Pending',
            approved: 'Approved',
            partially_delivered: 'Partially Delivered',
            delivered: 'Delivered',
            cancelled: 'Cancelled'
        };
        return statusLabels[status] || status;
    };

    if (dpList.length === 0) {
        return null;
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h2">
                    {title}
                </Typography>
                {showViewAll && (
                    <CustomButton
                        label="View all"
                        variant="text"
                        color="primary"
                        onClick={handleViewAll}
                        size='small'
                    />
                )}
            </Box>
            <Box sx={{ display: 'flex', gap: 1 , overflowX: { xs: 'scroll' }, pb: 1 , scrollbarWidth: 'none',
            '&::-webkit-scrollbar': { display: 'none' },}}>
                {dpList.map((dp, index) => (
                    <Box
                        key={dp.order_id || index}
                        sx={{
                            p: 1,
                            borderRadius: 2,
                            backgroundColor: '#fff',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1,
                            width: '292px',
                            minWidth: '292px',
                            flexShrink: 0,
                        }}
                    >
                        <Box sx={{ display: 'flex', flexDirection: "column",alignItems: 'flex-start', gap: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'space-between', width: '100%' }}>
                                <Typography variant="labelM" >
                                    {dayjs(dp.date).format('DD MMM YYYY')}
                                </Typography>
                                <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-end' }}>
                                    <Typography variant="labelM" sx={{ color: '#666' }}>
                                        Order ID
                                    </Typography>
                                    <Typography variant="p3">
                                        {dp.order_id || '-'}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '100%' }}>
                                <Typography variant="labelM" sx={{ color: '#666' }}>
                                    Ship to Party
                                </Typography>
                                {dp.ship_to_parties.map((party, pIndex) => (
                                    <Box key={pIndex} sx={{ display: 'flex' }}>
                                        <Typography variant="p3">
                                            {toCapitalized(party.company_name)}
                                        </Typography>
                                        {pIndex < dp.ship_to_parties.length - 1 && (
                                            <Typography variant="p3" sx={{ mx: 1, color: '#333333' }}>
                                                |
                                            </Typography>
                                        )}
                                    </Box>
                                ))}
                            </Box>
                            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'space-between', width: '100%' }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'flex-end' }}>
                                   {dp.quantity_info && dp.quantity_info.length > 0 && dp.quantity_info.map((quantity, qIndex) => (
                                        <Box key={qIndex} sx={{ display: 'flex', flexDirection: { xs: ',row',md:'column'}, gap: {xs: 2, md: 1} }}>
                                            <Typography variant="labelM" sx={{ color: '#666', minWidth: { xs: '80px', md: '100px' } }}>
                                                {quantity.label}
                                            </Typography>
                                            <Typography variant="p3">
                                                {quantity.value}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                                <Box sx={{ display: 'flex', gap: 1, mt: 0.5 }}>
                                    <StatusBadge
                                        label={getStatusLabel(dp.order_status)}
                                        status={getStatusColor(dp.order_status)}
                                        size="small"
                                    />
                                </Box>
                            </Box>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 'auto' }}>
                            <CustomButton
                                label="View Details"
                                variant="text"
                                color="primary"
                                size="small"
                                fullWidth
                                onClick={() => handleViewDetails(dp.order_id)}
                            />
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default DispatchStatusSection;